export default __webpack_public_path__ + "images/3df63268f64805c82a5cafefdc889f01-holiday_desktop.webp";